import {IUser} from "../Redux/Reducers/userData";

export type Permission = "control.manage.view" |
    "my.control.view" |
    "my.control.list.edit" |
    "control.manage.edit" |
    "control.manage.delete" |
    "post.control.view" |
    "external.control.view" |
    "external.control.edit" |
    "control.list.details.view" |
    "container.files.view" |
    "container.files.edit";

export function isPlanowana(control: any): boolean {
    return control?.controlStatus === 'Planowana'
}

export function isWTrakcieRealizacji(control: any): boolean {
    return control?.controlStatus === 'W_trakcie_realizacji'
}

export function hasPermission(control: any, permission: Permission): boolean {
    return (control?.action?.permissions || [] as Permission[]).includes(permission);
}

export function isZrealizowana(control: any): boolean {
    return control?.controlStatus === 'Zrealizowana'
}

export function getUserProgramsFromContext(user: IUser): string[] {
    return user?.roleDetails?.programDescriptors?.map(it => it.program).filter((el, idx, self) => self.indexOf(el) === idx);
}


export function prepareCorrectionTableArray(findings: any[], orders: any[]): {}[] {
    let corrections: {}[] = [];
    if(findings && findings.length>0) {

        let correctionCounter = 0;

        findings.forEach( (finding, index) => {
            if (finding.corrections.length > 0) {
                finding.corrections.filter((correction: any) => !correction.toRemove).forEach((correctionInfo: any, correctionIndex: number) => {
                    let correction: any = {};
                    correction.lp = correctionCounter + 1;
                    correction.id = correctionInfo.id;
                    correction.pseudoId = correctionInfo.pseudoId;
                    correction.findingNumber = finding.number;
                    correction.finding = [finding];
                    correction.findingKind = finding.findingKind ? finding.findingKind.name : "brak";
                    correction.rate = correctionInfo.rate;
                    correction.rateFormatted = correctionInfo.rate !== null ? formatCurrency(correctionInfo.rate, 2) + "%" : '';
                    correction.base = correctionInfo.base;
                    correction.baseFormatted = correctionInfo.base !== null ? formatCurrency(correctionInfo.base, 2) : '';
                    correction.wrongExpenditure = correctionInfo.wrongExpenditure;
                    correction.wrongExpenditureFormatted = formatCurrency(correctionInfo.wrongExpenditure, 2);
                    correction.kind = correctionInfo.kind;
                    correction.kindOption = correctionKindDict(correctionInfo.kind);
                    correction.paymentClaim = correctionInfo.paymentClaim ? [correctionInfo.paymentClaim] : null;
                    correction.number = correctionInfo.paymentClaim ? correctionInfo.paymentClaim.number : "brak";
                    correction.order = correctionInfo.order ? [correctionInfo.order] : "brak";
                    correction.orderNumber = (correctionInfo.order && correctionInfo.order.referenceId) ? mapOrderNumber(correctionInfo.order.referenceId, orders) : correctionInfo.order?.orderNumber ? correctionInfo.order?.orderNumber : "brak";
                    correction.influenceCurrent = correctionInfo.influenceCurrent;
                    correction.influenceCurrentOption = influenceDict(correctionInfo.influenceCurrent);
                    correction.influenceFuture = correctionInfo.influenceFuture;
                    correction.influenceFutureOption = influenceDict(correctionInfo.influenceFuture);
                    correction.indirectCosts = correctionInfo.indirectCosts;
                    correction.indirectCostsDisplay = correctionInfo.indirectCosts === true ? 'Tak' : correctionInfo.indirectCosts === false ? 'Nie' : '';
                    correction.projectNumber = correctionInfo.projectNumber;
                    corrections.push(correction);
                    correctionCounter += 1;
                })
            }

        })
    }
    return corrections;
}

export function formatCurrency(number: number, fractionDigits: number): string {
    return number !== undefined ? number.toLocaleString('pl-PL', {
        useGrouping: true,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }) : "";
}

export function mapOrderNumber(referenceOrderId: number, orders: any[]): string {
    return orders.find(order => order.id === referenceOrderId)?.orderNumber
}

export function correctionKindDict(kind: string): {} {
    switch(kind) {
        case 'dyferencyjna':
            return [{ordinal: 0, option: "dyferencyjna"}];
        case 'wskaźnikowa':
            return [{ordinal: 1, option: "wskaźnikowa"}];
        default:
            return [{ordinal: 2, option: "inna"}]
    }
}

export function influenceDict(influence: string): {} {
    switch(influence) {
        case 'TAK':
            return [{ordinal: 0, option: "TAK"}];
        case 'NIE':
            return [{ordinal: 1, option: "NIE"}];
        default:
            return [{ordinal: 2, option: "ND"}]
    }
}

export function formatSubject (type:string, name: string, nip: string, pesel: string, foreignNumber: string): string {
    switch (type) {
        case 'nip':
            return `${name} - NIP: ${nip}`;
        case 'pesel':
            return `${name} - PESEL: ${pesel}`;
        case 'foreignNumber':
            return `${name} - Nr zagraniczny: ${foreignNumber}`;
        default:
            return `${name} - Identyfikator: ${nip}`;
    }
};

export const numberFindingsByBlock = (findings: any[]) => {
    if (!Array.isArray(findings)) return [];
    const blocks = Array.from(new Map(findings.map(f => [f.blockInList.id, f.blockInList])).values()).sort((a, b) => a.id - b.id);
    let counter = 0;
    let numberedFindings: any[] = [];
    blocks.forEach(block => {
        counter += 1;
        const findingsInBlock = findings.filter(f => f.blockInList.id === block.id).map(f => ({ ...f }));
        findingsInBlock.sort((a, b) => a.id - b.id);
        findingsInBlock.forEach((f, idx) => { f.number = `${counter}.${idx + 1}` });
        numberedFindings = numberedFindings.concat(findingsInBlock);
    });
    return numberedFindings;
};

export const getUniqueBlocks = (findings: any[]) => {
    const blocks = Array.from(new Map(findings.map(f => [f.blockInList.id, f.blockInList])).values());
    return blocks.sort((a, b) => a.id - b.id);
};